import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import RankForm from './RankForm';
// import { initialValues  } from './initialValues-testing';
import { RequestBodyConverter } from '../RequestBodyConverter';
import { showRankApi, updateRankApi, clearEditedRank } from './rankSlice';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import uploadImage from '~/api/uploadImage';

function RankUpdate() {
    const { id } = useParams();
    const [resetCount, setResetCount] = useState(0);
    const { editedModel: initialValues, pictureAttributeNames } = useSelector((state) => state.heroSaga.rank);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (rawValues) => {
        let values = new RequestBodyConverter(rawValues);
        await values.convertPictures(rawValues, pictureAttributeNames);
        values = values.data;
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
        await uploadImage(rawValues, pictureAttributeNames, 'ranks');
        dispatch(updateRankApi({ navigate, values, id }));
    };

    useEffect(() => {
        dispatch(showRankApi({ navigate, id }));

        return () => dispatch(clearEditedRank());
    }, []);

    return (
        <RankForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={pictureAttributeNames}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default RankUpdate;
